module.exports = __webpack_public_path__ + "img/partner-ruangoutdoor.41768d38.png";